export default "__VITE_ASSET__cf663ef2__"